import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { errorHandler } from '@/shared/lib/errorHandler'
import { ChangePersonalManagerDto, topliApi } from '@/shared/api/topli/TopliApi'
import { defaultManagerQueryKey } from '@/entities/DefaultManager/api/default-manager-api'

export const changeDefaultManager = async (state: ChangePersonalManagerDto) => {
  const response = await topliApi.defaultManager.set(state)
  return response
}

export const useChangeDefaultManagerApi = (): UseMutationResult<any, Error, { id: string }> => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (state: { id: string }) => changeDefaultManager({ user_id: parseInt(state.id) }),
    onSuccess: async () => {
      try {
        await queryClient.invalidateQueries({
          queryKey: [defaultManagerQueryKey],
          refetchType: 'active',
        })
      } catch (error) {
        errorHandler(error)
      }
    },
  })
}
